import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/locationgcc/sa/saudiback.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner() {
  return (
    <div
      className="locationgcc_banner banner_hire_sa"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="KSA">
                <h1>
                  Hire the Best App Developers in <span>KSA</span>
                </h1>
              </div>
              <p className="main_para">
                Digitize your business by using the latest app development
                technologies. It's high time to collaborate with professional
                mobile app developers to streamline the workflow and as a
                result, you can increase your ROI by 2X.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                 Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
